import { request } from './request';

// 订阅
export const billingUsdtSubscribe = async (params = {}) => {
    const data = await request.post('/v1/billing/alipay/subscribe', params);

    return data;
};

// 加购
export const billingUsdtTokens = async (params = {}) => {
    const data = await request.post('/v1/billing/alipay/tokens', params);

    return data;
};

// 订阅记录
export const billingSubscribeList = async (params = {}) => {
    const data = await request.get('/v1/billing/subscribe', params);

    return data;
};

// 获取订单状态
export const getOrdersStatus = async (params = {}) => {
    const { id } = params;
    const data = await request.get(`/v1/billing/orders/${id}/status`, {});

    return data;
};
